import 'react';
import { Text as Text$1, P as P$1, A as A$1 } from '@lendi/ui';
import { jsx } from 'react/jsx-runtime';
import { map } from '@lendi-ui/breakpoint';
import styled, { css } from 'styled-components';
import { fg, color } from '@lendi-ui/color';
import { my, margin } from '@lendi-ui/spacing';
import { deriveSize } from '@lendi-ui/utils';
import getTypography from '@lendi-ui/commons/typography';
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var align = alignment => map(alignment, val => val && "text-align: ".concat(val, ";"));
var ellipsis = () => "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n";

/**
 * Body Options
 * Note: we recommend using the <Text> component instead
 */

var bodySizeMixin = size => map(size, val => {
  switch (val) {
    case 'xxs':
      return "\n        font-size: ".concat(deriveSize(0.625), ";\n        line-height: calc(14 / 10);\n      ");
    case 'xs':
      return "\n        font-size: ".concat(deriveSize(0.75), ";\n        line-height: calc(16 / 12);\n      ");
    case 'sm':
      return "\n        font-size: ".concat(deriveSize(0.875), ";\n        line-height: calc(20 / 14);\n      ");
    case 'md':
      return "\n        font-size: ".concat(deriveSize(1), ";\n        line-height: calc(24 / 16);\n      ");
    case 'lg':
      return "\n        font-size: ".concat(deriveSize(1.125), ";\n        line-height: calc(24 / 18);\n      ");
    case 'xl':
      return "\n        font-size: ".concat(deriveSize(1.5), ";\n        line-height: calc(30 / 24);\n      ");
    default:
      return undefined;
  }
});

/**
 * Body mixin
 */
var body = function body() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var {
    color,
    align: align$1,
    size
  } = options;
  return css(["", " ", " ", " font-family:", ";"], color && fg(color), align$1 && align(align$1), size && bodySizeMixin(size), getTypography('body1', 'fontFamily'));
};

/**
 * Body component
 */
var Body = styled.p.withConfig({
  displayName: "Body",
  componentId: "lui__sc-1yhxwuv-0"
})(["", " ", " ", ";"], my('nil'), body, margin);
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var _excluded$2 = ["as", "size"];
var headingSizeMixin = size => map(size, val => {
  switch (val) {
    case 'xxs':
      return "\n        font-size: ".concat(deriveSize(0.875), ";\n        font-weight: 400;\n        line-height: calc(20 / 14);\n      ");
    case 'xs':
      return "\n        font-size: ".concat(deriveSize(1.125), ";\n        font-weight: 400;\n        line-height: calc(24 / 18);\n      ");
    case 'sm':
      return "\n        font-size: ".concat(deriveSize(1.375), ";\n        font-weight: 400;\n        line-height: calc(28 / 22);\n      ");
    case 'md':
      return "\n        font-size: ".concat(deriveSize(1.75), ";\n        font-weight: 400;\n        line-height: calc(32 / 28);\n      ");
    case 'lg':
      return "\n        font-size: ".concat(deriveSize(2.3125), ";\n        font-weight: 400;\n        line-height: calc(40 / 37);\n      ");
    case 'xl':
      return "\n        font-size: ".concat(deriveSize(2.875), ";\n        font-weight: 600;\n        line-height: calc(50 / 46);\n      ");
    default:
      return undefined;
  }
});
var heading = options => {
  var {
    color,
    align: align$1,
    size
  } = options;
  return css(["", " ", " ", " font-family:", ";"], color && fg(color), align$1 && align(align$1), headingSizeMixin(size), getTypography('title1', 'fontFamily'));
};
var componentBySize = size => map(size, val => {
  switch (val) {
    case 'xxs':
      return 'h6';
    case 'xs':
      return 'h5';
    case 'sm':
      return 'h4';
    case 'md':
      return 'h3';
    case 'lg':
      return 'h2';
    case 'xl':
      return 'h1';
    default:
      return 'h1';
  }
});

/**
 * Heading Props
 * Note: we recommend using the <Text> component instead
 */

var HeadingTag = _ref => {
  var {
      as,
      size
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded$2);
  var Component = as !== null && as !== void 0 ? as : typeof size !== 'object' ? componentBySize(size) : 'h1';
  return /*#__PURE__*/jsx(Component, _objectSpread2({
    size: size
  }, otherProps));
};

/**
 * Heading Component
 * Not recommended: Use <Text> or <P> component instead
 */
var Heading = styled(HeadingTag).withConfig({
  displayName: "Heading",
  componentId: "lui__sc-37fddq-0"
})(["", " ", " ", ";"], my('nil'), heading, margin);
var _excluded$1 = ["href", "children", "target", "type"];
/**
 * Link mixin
 */

var link = function link() {
  var {
    color: color$1,
    size
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return css(["", " font-weight:bold;cursor:pointer;text-decoration:underline;color:", ";&:hover,&:focus,&:active{text-decoration:underline;}"], body({
    size
  }), color$1 ? color(color$1) : 'currentColor');
};

/**
 * Link component
 */
var LinkWrapper$1 = styled.a.withConfig({
  displayName: "Link__LinkWrapper",
  componentId: "lui__sc-7ivhe6-0"
})(["", ";", ";"], link, margin);
var ButtonWrapper = styled.button.withConfig({
  displayName: "Link__ButtonWrapper",
  componentId: "lui__sc-7ivhe6-1"
})(["font-size:1em;border:none;padding:0;", ";", ";background-color:inherit;"], link, margin);
var Link = props => {
  var {
      href,
      children,
      target = '_self',
      type
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded$1);
  if (href) {
    return /*#__PURE__*/jsx(LinkWrapper$1, _objectSpread2(_objectSpread2({
      href: href,
      target: target
    }, otherProps), {}, {
      children: children
    }));
  } else {
    return /*#__PURE__*/jsx(ButtonWrapper, _objectSpread2(_objectSpread2({}, otherProps), {}, {
      type: type,
      children: children
    }));
  }
};
var _excluded = ["href", "children"];
var overlineSizeMixin = size => map(size, val => {
  switch (val) {
    case 'xxs':
    case 'xs':
    case 'sm':
      return "\n        font-size: ".concat(deriveSize(0.625), ";\n        line-height: ").concat(deriveSize(0.625), ";\n        letter-spacing: calc(").concat(deriveSize(0.625), "/10);\n      ");
    case 'md':
      return "\n        font-size: ".concat(deriveSize(0.75), ";\n        line-height: ").concat(deriveSize(0.75), ";\n        letter-spacing: calc(").concat(deriveSize(0.75), "/10);\n      ");
    case 'lg':
      return "\n        font-size: ".concat(deriveSize(0.875), ";\n        line-height: ").concat(deriveSize(0.875), ";\n        letter-spacing: calc(").concat(deriveSize(0.875), "/10);\n      ");
    case 'xl':
      return "\n        font-size: ".concat(deriveSize(1), ";\n        line-height: ").concat(deriveSize(1), ";\n        letter-spacing: calc(").concat(deriveSize(1), "/10);\n      ");
    default:
      return undefined;
  }
});
/**
 * Overline mixin
 */
var overline = options => {
  var {
    colorScheme,
    size,
    align: align$1
  } = options;
  var color;
  if (colorScheme === 'dark') {
    color = 'shade.0';
  } else {
    color = 'shade.400';
  }
  return css(["display:block;font-family:", ";text-transform:uppercase;font-weight:", ";", " ", " ", " text-decoration:none;"], getTypography('overline', 'fontFamily'), getTypography('overline', 'fontWeight'), overlineSizeMixin(size), align$1 && align(align$1), color && fg(color));
};

/**
 * Overline Link Mixin
 */
var overlineLink = options => {
  var {
    colorScheme
  } = options;
  var linkColor;
  var stateColor;
  if (colorScheme === 'dark') {
    linkColor = 'primary.200';
    stateColor = 'primary.200';
  } else {
    linkColor = 'primary.500';
    stateColor = 'primary.700';
  }
  return css(["cursor:pointer;", ";text-decoration:none;&:hover{text-decoration:underline;}&:hover,&:focus,&:active{", ";}"], fg(linkColor), fg(stateColor));
};

/**
 * Overline component
 */
var LinkWrapper = styled.a.withConfig({
  displayName: "Overline__LinkWrapper",
  componentId: "lui__sc-1i5xmqs-0"
})(["", " ", " ", ";"], overline, overlineLink, margin);
var TextWrapper = styled.span.withConfig({
  displayName: "Overline__TextWrapper",
  componentId: "lui__sc-1i5xmqs-1"
})(["", ";", ";"], overline, margin);
var Overline = props => {
  var {
      href,
      children
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  if (href) {
    return /*#__PURE__*/jsx(LinkWrapper, _objectSpread2(_objectSpread2({
      href: href
    }, otherProps), {}, {
      children: children
    }));
  } else {
    return /*#__PURE__*/jsx(TextWrapper, _objectSpread2(_objectSpread2({}, otherProps), {}, {
      children: children
    }));
  }
};

/**
 * @deprecated Importing from '@lendi-ui/typography' is deprecated, import directly from '@lendi/ui' instead.
 * @example import { Text } from '@lendi/ui';
 * @see https://lendi.styls/
 */
var Text = props => {
  return /*#__PURE__*/jsx(Text$1, _objectSpread2(_objectSpread2({}, props), {}, {
    children: props.children
  }));
};

/**
 * @deprecated Importing from '@lendi-ui/typography' is deprecated, import directly from '@lendi/ui' instead.
 * @example import { P } from '@lendi/ui';
 * @see https://lendi.styls/
 */
var P = props => {
  return /*#__PURE__*/jsx(P$1, _objectSpread2(_objectSpread2({}, props), {}, {
    children: "props.children"
  }));
};

/**
 * @deprecated Importing from '@lendi-ui/typography' is deprecated, import directly from '@lendi/ui' instead.
 * @example import { A } from '@lendi/ui';
 * @see https://lendi.styls/
 */
var A = props => {
  return /*#__PURE__*/jsx(A$1, _objectSpread2(_objectSpread2({}, props), {}, {
    children: "props.children"
  }));
};
export { A, Body, Heading, Link, Overline, P, Text, align, body, Text as default, ellipsis, heading, link, overline, overlineLink };